import React from 'react'
import PropTypes from 'prop-types'

import { News } from '../../../../../../../../entities/News'

import { RCRelatedNewsItem } from './RCRelatedNewsItem/RCRelatedNewsItem'

import './RCRelatedNewsList.css'

const RCRelatedNewsList = ({ relatedNewsList }) => (
    <div className="rc-related-news-list">
        {relatedNewsList.map((relatedArticle, i) => (
            <RCRelatedNewsItem relatedArticle={relatedArticle} key={i} />
        ))}
    </div>
)

RCRelatedNewsList.propTypes = {
    relatedNewsList: PropTypes.arrayOf(PropTypes.instanceOf(News))
}

export { RCRelatedNewsList }
